/* Sticky-Kaufleiste: erscheint, wenn der Original-Kaufbutton aus dem Bild scrollt; Klick löst den Original-Button aus. */
(function () {
  function setup(bar) {
    var info = document.getElementById(bar.dataset.target);
    if (!info) return;
    var submit = info.querySelector('.product-form__submit');
    if (!submit) return;
    var priceTarget = bar.querySelector('[data-bv-sticky-price]');
    var button = bar.querySelector('[data-bv-sticky-button]');

    // Ausverkauft-Zustand des Original-Buttons auf die Sticky-Leiste übertragen
    function syncState() {
      button.disabled = submit.disabled;
      bar.classList.toggle('is-disabled', submit.disabled);
    }
    syncState();

    // Sichtbarkeit über IntersectionObserver auf den Original-Button
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      bar.classList.toggle('is-visible', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0 });
    observer.observe(submit);

    // Preis und Ausverkauft-Zustand nachziehen, wenn Dawn die Variante wechselt
    // Der Zustand (Ausverkauft) muss immer gespiegelt werden, auch ohne Preisquelle
    new MutationObserver(function () {
      var src = info.querySelector('.price__regular .price-item--regular, .price-item--sale');
      if (src && priceTarget) priceTarget.textContent = src.textContent.trim();
      syncState();
    }).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    button.addEventListener('click', function () {
      syncState();
      if (submit.disabled) return;
      submit.click();
    });
  }
  document.querySelectorAll('[data-bv-sticky]').forEach(setup);
})();
